
export const EC_SHOP = "SHOP";

export const E_ADD_TO_BASKET = "ADD_TO_BASKET";
export const E_REMOVE_FROM_BASKET = "REMOVE_FROM_BASKET";
export const E_VIEW_PRODUCT_DETAILS = "VIEW_PRODUCT_DETAILS";
export const E_GONE_TO_CHECKOUT = "GONE_TO_CHECKOUT";
export const E_ORDER_COMPLETED = "ORDER_COMPLETED";
export const E_CATEGORY_OPENED = "CATEGORY_OPENED";
export const E_CATEGORY_CLOSED = "CATEGORY_CLOSED";

export const EC_ACCOUNT = "ACCOUNT";

export const E_CREATE_PRODUCT = "CREATE_PRODUCT";
export const E_CREATE_PRODUCT_VARIANT = "CREATE_PRODUCT_VARIANT";
export const E_DELETE_PRODUCT = "DELETE_PRODUCT";
export const E_UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const E_UPDATE_PROFILE = "UPDATE_PROFILE";
export const E_UPDATE_SHOP = "UPDATE_SHOP";
export const E_UPDATE_ORDER = "UPDATE_ORDER";
export const E_CHANGE_ORDER_STATUS = "CHANGE_ORDER_STATUS";
export const E_OPEN_NAVIGATION = "OPEN_NAVIGATION";
export const E_CLOSE_NAVIGATION = "CLOSE_NAVIGATION";
export const E_CREATE_SHOP = "CREATE_SHOP";

export function trackPageView(pathname) {
	// Track navigation with hubspot.
	if (window._hsq) {
		window._hsq.push(['setPath', pathname]);
		window._hsq.push(['trackPageView']);
	}
	// Track for google analytics.
	if (window.ga && window.ga.getAll) {
		const [tracker] = window.ga.getAll();
		if (tracker) {
			tracker.set("page", pathname);
			tracker.send("pageview");
		}
	}
}

export function trackEvent(category, action, label) {
	if (window.ga && window.ga.getAll) {
		const [tracker] = window.ga.getAll();
		if (tracker) {
			tracker.send("event", ...[category, action, label].filter(a => a));
		}
	}
}